import { IconProps } from "../../utils/global-types/global-types";

const ToastSuccessIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <mask
        id="mask0_8319_124435"
        width="20"
        height="20"
        x="-1"
        y="-1"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#D9D9D9" d="M-1-1h20v20H-1z"></path>
      </mask>
      <g mask="url(#mask0_8319_124435)">
        <path
          fill="#25D366"
          d="m7.833 12.833 5.875-5.875-1.167-1.166L7.833 10.5 5.458 8.125 4.292 9.292zM9 17.333a8.1 8.1 0 0 1-3.25-.656 8.4 8.4 0 0 1-2.646-1.781 8.4 8.4 0 0 1-1.78-2.646A8.1 8.1 0 0 1 .666 9a8.1 8.1 0 0 1 .656-3.25 8.4 8.4 0 0 1 1.781-2.646A8.4 8.4 0 0 1 5.75 1.323 8.1 8.1 0 0 1 9 .667q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.78 2.646A8.1 8.1 0 0 1 17.334 9a8.1 8.1 0 0 1-.656 3.25 8.4 8.4 0 0 1-1.781 2.646 8.4 8.4 0 0 1-2.646 1.78 8.1 8.1 0 0 1-3.25.657"
        ></path>
      </g>
    </svg>
  );
};

export default ToastSuccessIcon;
